import { useContext } from 'react';

import { AuthenticationClientContext } from '@dashboard/contexts/AuthenticationClientManager';

export default function useDashboardClient() {
  const context = useContext(AuthenticationClientContext);
  if (context === null) {
    throw new Error('useDashboardClient must be used within a PlatformManager');
  }
  return context.authenticationClient;
}
